module.exports = __webpack_public_path__ + "img/office-overview-blur.10dfcedd.jpg";